import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  size?: 'small' | 'medium' | 'large';
}

export default function ArticleCard({ article, size = 'medium' }: ArticleCardProps) {
  const isLarge = size === 'large';
  const isSmall = size === 'small';

  return (
    <Link
      to={`/article/${article.id}`}
      className="group block bg-background-100 rounded-lg overflow-hidden border border-background-200/30 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
    >
      <div className={`relative overflow-hidden ${isLarge ? 'aspect-[16/9]' : isSmall ? 'aspect-[3/4]' : 'aspect-[2/3]'}`}>
        <img
          src={article.coverImage}
          alt={`${article.title} - 91制片厂原创影视作品`}
          title={`${article.title} - 91制片厂${article.categoryName}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent"></div>
        <div className="absolute top-3 left-3 flex items-center gap-2">
          <span className="px-2.5 py-1 text-xs font-medium bg-primary-500/90 text-background-50 rounded-full whitespace-nowrap">
            {article.quality}
          </span>
          {article.featured && (
            <span className="px-2.5 py-1 text-xs font-medium bg-accent-500/90 text-background-950 rounded-full whitespace-nowrap">
              精选
            </span>
          )}
        </div>
        <div className="absolute bottom-3 left-3 right-3">
          <div className="flex items-center gap-3 text-xs text-foreground-200 mb-1">
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {article.duration}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              {article.rating}
            </span>
          </div>
        </div>
      </div>
      <div className={`${isSmall ? 'p-3' : 'p-4'}`}>
        <h3 className={`font-heading font-semibold text-foreground-50 group-hover:text-primary-400 transition-colors duration-200 line-clamp-1 ${isSmall ? 'text-sm' : 'text-base'}`}>
          {article.title}
        </h3>
        <p className={`text-foreground-400 mt-1.5 line-clamp-2 leading-relaxed ${isSmall ? 'text-xs' : 'text-sm'}`}>
          {article.summary}
        </p>
        {!isSmall && (
          <div className="flex items-center gap-2 mt-3 flex-wrap">
            <span className="px-2 py-0.5 text-xs text-primary-400 bg-primary-500/10 rounded-full whitespace-nowrap">
              {article.categoryName}
            </span>
            {article.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 text-xs text-foreground-400 bg-background-200/50 rounded-full whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}